import {
    ADD_CART,
    OBTENER_PRODUCTOS,
    OBTENER_PRODUCTO,
    REMOVE_CART,
    CREAR_PRODUCTO,
    OBTENER_CARRITO,
    OBTENER_ORDEN,
    OBTENER_ORDENES
} from '../../types';

export default (state, action) => {

    switch (action.type) {

        case OBTENER_PRODUCTOS:
            return {
                ...state,
                productos: action.payload
            }
        case OBTENER_PRODUCTO:
            return {
                ...state,
                producto: action.payload
            }
        case CREAR_PRODUCTO:
            return {
                ...state,
                productos: [...state.productos, action.payload]
            }
        case ADD_CART:
            // Verifica si el producto ya existe en el carrito
            const existingProduct = state.cart?.find(producto => producto.id === action.payload?.id);
            return {
                ...state,
                cart: existingProduct
                    ? state.cart.map(producto =>
                        producto.id === action.payload.id
                            ? { ...producto, cantidad: action.payload.cantidad, color: action.payload.color } // Actualiza la cantidad
                            : {...producto, color: action.payload.color }
                    )
                    : [...state.cart, { ...action.payload }] // Crea una copia del producto al agregarlo
            }
        case OBTENER_CARRITO:
            return {
                ...state,
                cart: action.payload
            }
        case OBTENER_ORDENES:
            return {
                ...state,
                ordenes: action.payload
            }
        case OBTENER_ORDEN:
            return {
                ...state,
                orden: action.payload
            }
        case REMOVE_CART:
            return {
                ...state,
                cart: state.cart.filter(producto => producto.id !== action.payload)
            }
        default:
            return state;
    }
}